// extracted by mini-css-extract-plugin
module.exports = {"segment":"styles_segment__2xz7q","projectedText":"styles_projectedText__1aEzv","arrow":"styles_arrow__1x2Nd","popup":"styles_popup__kHbe2"};